import styles from './index.less';
import React from 'react';

interface IFloatButtonProps {
  type: 'community' | 'house';
  btnClick?: () => void;
}

const FloatButton: React.FC<IFloatButtonProps> = (props) => {
  const { type, btnClick } = props;
  return (
    <div className={styles.container}>
      <div onClick={btnClick}>{`新增${
        type === 'community' ? '小区' : '房屋'
      }`}</div>
    </div>
  );
};

export default FloatButton;
